import { useState, useEffect } from 'react'
import { getWebClient } from '@/services/ApolloClient'
import { getSweepstake } from '@/services/SweepstakeService'
import { SweepstakeObject } from '@/types/codegen-federation'

export const useSweepstakeData = (theatricalSlug: string) => {
  const [sweepstake, setSweepstake] = useState<SweepstakeObject | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    const fetchSweepstake = async () => {
      try {
        setLoading(true)
        setError(null)
        const client = getWebClient()
        const result = await getSweepstake(client, theatricalSlug)
        setSweepstake(result)
      } catch (err) {
        setError(err as Error)
      } finally {
        setLoading(false)
      }
    }

    if (theatricalSlug) {
      fetchSweepstake().catch((err) => {
        setError(err as Error)
      })
    }
  }, [theatricalSlug])

  return {
    sweepstake,
    isActive: sweepstake?.status === 'LIVE',
    sweepstakeLoading: loading,
    error,
  }
}
